/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignupPendingRouteImport } from './routes/(auth)/signup-pending'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedOutcomesIndexRouteImport } from './routes/_authenticated/outcomes/index'
import { Route as AuthenticatedOptimizationIndexRouteImport } from './routes/_authenticated/optimization/index'
import { Route as AuthenticatedMonitoringIndexRouteImport } from './routes/_authenticated/monitoring/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedInstancesIndexRouteImport } from './routes/_authenticated/instances/index'
import { Route as AuthenticatedInsightsIndexRouteImport } from './routes/_authenticated/insights/index'
import { Route as AuthenticatedCopilotIndexRouteImport } from './routes/_authenticated/copilot/index'
import { Route as AuthenticatedComplianceIndexRouteImport } from './routes/_authenticated/compliance/index'
import { Route as AuthenticatedCommandCenterIndexRouteImport } from './routes/_authenticated/command-center/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedBackupsIndexRouteImport } from './routes/_authenticated/backups/index'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedAlertsIndexRouteImport } from './routes/_authenticated/alerts/index'
import { Route as AuthenticatedAgentsIndexRouteImport } from './routes/_authenticated/agents/index'
import { Route as AuthenticatedAccessGovernanceIndexRouteImport } from './routes/_authenticated/access-governance/index'
import { Route as ClerkAuthenticatedUserManagementRouteImport } from './routes/clerk/_authenticated/user-management'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedSettingsReportSubscriptionsRouteImport } from './routes/_authenticated/settings/report-subscriptions'
import { Route as AuthenticatedSettingsReportProfilesRouteImport } from './routes/_authenticated/settings/report-profiles'
import { Route as AuthenticatedSettingsPostActionsRouteImport } from './routes/_authenticated/settings/post-actions'
import { Route as AuthenticatedSettingsOptimizationRouteImport } from './routes/_authenticated/settings/optimization'
import { Route as AuthenticatedSettingsGovernedToolsRouteImport } from './routes/_authenticated/settings/governed-tools'
import { Route as AuthenticatedSettingsAgentKeysRouteImport } from './routes/_authenticated/settings/agent-keys'
import { Route as AuthenticatedReportsNewRouteImport } from './routes/_authenticated/reports/new'
import { Route as AuthenticatedReportsRunIdRouteImport } from './routes/_authenticated/reports/$runId'
import { Route as AuthenticatedPacksPackSlugRouteImport } from './routes/_authenticated/packs/$packSlug'
import { Route as AuthenticatedOptimizationBillingRouteImport } from './routes/_authenticated/optimization/billing'
import { Route as AuthenticatedInstancesInstanceIdRouteImport } from './routes/_authenticated/instances/$instanceId'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedCommandCenterSanitizeRouteImport } from './routes/_authenticated/command-center/sanitize'
import { Route as AuthenticatedCommandCenterPiiRouteImport } from './routes/_authenticated/command-center/pii'
import { Route as AuthenticatedCommandCenterDriftRouteImport } from './routes/_authenticated/command-center/drift'
import { Route as AuthenticatedCommandCenterDataCatalogRouteImport } from './routes/_authenticated/command-center/data-catalog'
import { Route as AuthenticatedAutomationPackStudioRouteImport } from './routes/_authenticated/automation/pack-studio'
import { Route as AuthenticatedAutomationMonitorsRouteImport } from './routes/_authenticated/automation/monitors'
import { Route as AuthenticatedAutomationGovernedToolsRouteImport } from './routes/_authenticated/automation/governed-tools'
import { Route as AuthenticatedOptimizationOpportunitiesIndexRouteImport } from './routes/_authenticated/optimization/opportunities/index'
import { Route as AuthenticatedInstancesInstanceIdIndexRouteImport } from './routes/_authenticated/instances/$instanceId/index'
import { Route as AuthenticatedAutomationTemplatesIndexRouteImport } from './routes/_authenticated/automation/templates/index'
import { Route as AuthenticatedAutomationPostActionsIndexRouteImport } from './routes/_authenticated/automation/post-actions/index'
import { Route as AuthenticatedAgentsAgentIdIndexRouteImport } from './routes/_authenticated/agents/$agentId/index'
import { Route as AuthenticatedOptimizationOpportunitiesOpportunityIdRouteImport } from './routes/_authenticated/optimization/opportunities/$opportunityId'
import { Route as AuthenticatedInstancesInstanceIdPacksRouteImport } from './routes/_authenticated/instances/$instanceId/packs'
import { Route as AuthenticatedInstancesInstanceIdOperationsRouteImport } from './routes/_authenticated/instances/$instanceId/operations'
import { Route as AuthenticatedInstancesInstanceIdInsightsRouteImport } from './routes/_authenticated/instances/$instanceId/insights'
import { Route as AuthenticatedInstancesInstanceIdFindingsRouteImport } from './routes/_authenticated/instances/$instanceId/findings'
import { Route as AuthenticatedInstancesInstanceIdComplianceRouteImport } from './routes/_authenticated/instances/$instanceId/compliance'
import { Route as AuthenticatedInstancesInstanceIdAlertsRouteImport } from './routes/_authenticated/instances/$instanceId/alerts'
import { Route as AuthenticatedInstancesInstanceIdAccessRouteImport } from './routes/_authenticated/instances/$instanceId/access'
import { Route as AuthenticatedAutomationTemplatesCreateRouteImport } from './routes/_authenticated/automation/templates/create'
import { Route as AuthenticatedAutomationTemplatesTemplateIdRouteImport } from './routes/_authenticated/automation/templates/$templateId'
import { Route as AuthenticatedInstancesInstanceIdPacksIndexRouteImport } from './routes/_authenticated/instances/$instanceId/packs.index'
import { Route as AuthenticatedInstancesInstanceIdDiagnosticsIndexRouteImport } from './routes/_authenticated/instances/$instanceId/diagnostics/index'
import { Route as AuthenticatedInstancesInstanceIdPacksPackSlugRouteImport } from './routes/_authenticated/instances/$instanceId/packs.$packSlug'
import { Route as AuthenticatedInstancesInstanceIdDiagnosticsResultIdRouteImport } from './routes/_authenticated/instances/$instanceId/diagnostics/$resultId'
import { Route as AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRouteImport } from './routes/_authenticated/copilot/$instanceId/suggestions/$suggestionId'
import { Route as AuthenticatedAutomationTemplatesTemplateIdEditRouteImport } from './routes/_authenticated/automation/templates/$templateId.edit'

const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignupPendingRoute = authSignupPendingRouteImport.update({
  id: '/(auth)/signup-pending',
  path: '/signup-pending',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOutcomesIndexRoute =
  AuthenticatedOutcomesIndexRouteImport.update({
    id: '/outcomes/',
    path: '/outcomes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOptimizationIndexRoute =
  AuthenticatedOptimizationIndexRouteImport.update({
    id: '/optimization/',
    path: '/optimization/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMonitoringIndexRoute =
  AuthenticatedMonitoringIndexRouteImport.update({
    id: '/monitoring/',
    path: '/monitoring/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInstancesIndexRoute =
  AuthenticatedInstancesIndexRouteImport.update({
    id: '/instances/',
    path: '/instances/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInsightsIndexRoute =
  AuthenticatedInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCopilotIndexRoute =
  AuthenticatedCopilotIndexRouteImport.update({
    id: '/copilot/',
    path: '/copilot/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedComplianceIndexRoute =
  AuthenticatedComplianceIndexRouteImport.update({
    id: '/compliance/',
    path: '/compliance/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCommandCenterIndexRoute =
  AuthenticatedCommandCenterIndexRouteImport.update({
    id: '/command-center/',
    path: '/command-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBackupsIndexRoute =
  AuthenticatedBackupsIndexRouteImport.update({
    id: '/backups/',
    path: '/backups/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAlertsIndexRoute =
  AuthenticatedAlertsIndexRouteImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsIndexRoute =
  AuthenticatedAgentsIndexRouteImport.update({
    id: '/agents/',
    path: '/agents/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAccessGovernanceIndexRoute =
  AuthenticatedAccessGovernanceIndexRouteImport.update({
    id: '/access-governance/',
    path: '/access-governance/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ClerkAuthenticatedUserManagementRoute =
  ClerkAuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => ClerkAuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedSettingsReportSubscriptionsRoute =
  AuthenticatedSettingsReportSubscriptionsRouteImport.update({
    id: '/report-subscriptions',
    path: '/report-subscriptions',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsReportProfilesRoute =
  AuthenticatedSettingsReportProfilesRouteImport.update({
    id: '/report-profiles',
    path: '/report-profiles',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsPostActionsRoute =
  AuthenticatedSettingsPostActionsRouteImport.update({
    id: '/post-actions',
    path: '/post-actions',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsOptimizationRoute =
  AuthenticatedSettingsOptimizationRouteImport.update({
    id: '/optimization',
    path: '/optimization',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsGovernedToolsRoute =
  AuthenticatedSettingsGovernedToolsRouteImport.update({
    id: '/governed-tools',
    path: '/governed-tools',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAgentKeysRoute =
  AuthenticatedSettingsAgentKeysRouteImport.update({
    id: '/agent-keys',
    path: '/agent-keys',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedReportsNewRoute = AuthenticatedReportsNewRouteImport.update({
  id: '/reports/new',
  path: '/reports/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedReportsRunIdRoute =
  AuthenticatedReportsRunIdRouteImport.update({
    id: '/reports/$runId',
    path: '/reports/$runId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPacksPackSlugRoute =
  AuthenticatedPacksPackSlugRouteImport.update({
    id: '/packs/$packSlug',
    path: '/packs/$packSlug',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOptimizationBillingRoute =
  AuthenticatedOptimizationBillingRouteImport.update({
    id: '/optimization/billing',
    path: '/optimization/billing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInstancesInstanceIdRoute =
  AuthenticatedInstancesInstanceIdRouteImport.update({
    id: '/instances/$instanceId',
    path: '/instances/$instanceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCommandCenterSanitizeRoute =
  AuthenticatedCommandCenterSanitizeRouteImport.update({
    id: '/command-center/sanitize',
    path: '/command-center/sanitize',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCommandCenterPiiRoute =
  AuthenticatedCommandCenterPiiRouteImport.update({
    id: '/command-center/pii',
    path: '/command-center/pii',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCommandCenterDriftRoute =
  AuthenticatedCommandCenterDriftRouteImport.update({
    id: '/command-center/drift',
    path: '/command-center/drift',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCommandCenterDataCatalogRoute =
  AuthenticatedCommandCenterDataCatalogRouteImport.update({
    id: '/command-center/data-catalog',
    path: '/command-center/data-catalog',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAutomationPackStudioRoute =
  AuthenticatedAutomationPackStudioRouteImport.update({
    id: '/automation/pack-studio',
    path: '/automation/pack-studio',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAutomationMonitorsRoute =
  AuthenticatedAutomationMonitorsRouteImport.update({
    id: '/automation/monitors',
    path: '/automation/monitors',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAutomationGovernedToolsRoute =
  AuthenticatedAutomationGovernedToolsRouteImport.update({
    id: '/automation/governed-tools',
    path: '/automation/governed-tools',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOptimizationOpportunitiesIndexRoute =
  AuthenticatedOptimizationOpportunitiesIndexRouteImport.update({
    id: '/optimization/opportunities/',
    path: '/optimization/opportunities/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInstancesInstanceIdIndexRoute =
  AuthenticatedInstancesInstanceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedAutomationTemplatesIndexRoute =
  AuthenticatedAutomationTemplatesIndexRouteImport.update({
    id: '/automation/templates/',
    path: '/automation/templates/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAutomationPostActionsIndexRoute =
  AuthenticatedAutomationPostActionsIndexRouteImport.update({
    id: '/automation/post-actions/',
    path: '/automation/post-actions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAgentsAgentIdIndexRoute =
  AuthenticatedAgentsAgentIdIndexRouteImport.update({
    id: '/agents/$agentId/',
    path: '/agents/$agentId/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOptimizationOpportunitiesOpportunityIdRoute =
  AuthenticatedOptimizationOpportunitiesOpportunityIdRouteImport.update({
    id: '/optimization/opportunities/$opportunityId',
    path: '/optimization/opportunities/$opportunityId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInstancesInstanceIdPacksRoute =
  AuthenticatedInstancesInstanceIdPacksRouteImport.update({
    id: '/packs',
    path: '/packs',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdOperationsRoute =
  AuthenticatedInstancesInstanceIdOperationsRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdInsightsRoute =
  AuthenticatedInstancesInstanceIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdFindingsRoute =
  AuthenticatedInstancesInstanceIdFindingsRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdComplianceRoute =
  AuthenticatedInstancesInstanceIdComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdAlertsRoute =
  AuthenticatedInstancesInstanceIdAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdAccessRoute =
  AuthenticatedInstancesInstanceIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedAutomationTemplatesCreateRoute =
  AuthenticatedAutomationTemplatesCreateRouteImport.update({
    id: '/automation/templates/create',
    path: '/automation/templates/create',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAutomationTemplatesTemplateIdRoute =
  AuthenticatedAutomationTemplatesTemplateIdRouteImport.update({
    id: '/automation/templates/$templateId',
    path: '/automation/templates/$templateId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInstancesInstanceIdPacksIndexRoute =
  AuthenticatedInstancesInstanceIdPacksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInstancesInstanceIdPacksRoute,
  } as any)
const AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute =
  AuthenticatedInstancesInstanceIdDiagnosticsIndexRouteImport.update({
    id: '/diagnostics/',
    path: '/diagnostics/',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedInstancesInstanceIdPacksPackSlugRoute =
  AuthenticatedInstancesInstanceIdPacksPackSlugRouteImport.update({
    id: '/$packSlug',
    path: '/$packSlug',
    getParentRoute: () => AuthenticatedInstancesInstanceIdPacksRoute,
  } as any)
const AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute =
  AuthenticatedInstancesInstanceIdDiagnosticsResultIdRouteImport.update({
    id: '/diagnostics/$resultId',
    path: '/diagnostics/$resultId',
    getParentRoute: () => AuthenticatedInstancesInstanceIdRoute,
  } as any)
const AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute =
  AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRouteImport.update({
    id: '/copilot/$instanceId/suggestions/$suggestionId',
    path: '/copilot/$instanceId/suggestions/$suggestionId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAutomationTemplatesTemplateIdEditRoute =
  AuthenticatedAutomationTemplatesTemplateIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedAutomationTemplatesTemplateIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/': typeof ClerkauthRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/signup-pending': typeof authSignupPendingRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/automation/governed-tools': typeof AuthenticatedAutomationGovernedToolsRoute
  '/automation/monitors': typeof AuthenticatedAutomationMonitorsRoute
  '/automation/pack-studio': typeof AuthenticatedAutomationPackStudioRoute
  '/command-center/data-catalog': typeof AuthenticatedCommandCenterDataCatalogRoute
  '/command-center/drift': typeof AuthenticatedCommandCenterDriftRoute
  '/command-center/pii': typeof AuthenticatedCommandCenterPiiRoute
  '/command-center/sanitize': typeof AuthenticatedCommandCenterSanitizeRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/instances/$instanceId': typeof AuthenticatedInstancesInstanceIdRouteWithChildren
  '/optimization/billing': typeof AuthenticatedOptimizationBillingRoute
  '/packs/$packSlug': typeof AuthenticatedPacksPackSlugRoute
  '/reports/$runId': typeof AuthenticatedReportsRunIdRoute
  '/reports/new': typeof AuthenticatedReportsNewRoute
  '/settings/agent-keys': typeof AuthenticatedSettingsAgentKeysRoute
  '/settings/governed-tools': typeof AuthenticatedSettingsGovernedToolsRoute
  '/settings/optimization': typeof AuthenticatedSettingsOptimizationRoute
  '/settings/post-actions': typeof AuthenticatedSettingsPostActionsRoute
  '/settings/report-profiles': typeof AuthenticatedSettingsReportProfilesRoute
  '/settings/report-subscriptions': typeof AuthenticatedSettingsReportSubscriptionsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/access-governance': typeof AuthenticatedAccessGovernanceIndexRoute
  '/agents': typeof AuthenticatedAgentsIndexRoute
  '/alerts': typeof AuthenticatedAlertsIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/backups': typeof AuthenticatedBackupsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/command-center': typeof AuthenticatedCommandCenterIndexRoute
  '/compliance': typeof AuthenticatedComplianceIndexRoute
  '/copilot': typeof AuthenticatedCopilotIndexRoute
  '/insights': typeof AuthenticatedInsightsIndexRoute
  '/instances': typeof AuthenticatedInstancesIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/monitoring': typeof AuthenticatedMonitoringIndexRoute
  '/optimization': typeof AuthenticatedOptimizationIndexRoute
  '/outcomes': typeof AuthenticatedOutcomesIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/automation/templates/$templateId': typeof AuthenticatedAutomationTemplatesTemplateIdRouteWithChildren
  '/automation/templates/create': typeof AuthenticatedAutomationTemplatesCreateRoute
  '/instances/$instanceId/access': typeof AuthenticatedInstancesInstanceIdAccessRoute
  '/instances/$instanceId/alerts': typeof AuthenticatedInstancesInstanceIdAlertsRoute
  '/instances/$instanceId/compliance': typeof AuthenticatedInstancesInstanceIdComplianceRoute
  '/instances/$instanceId/findings': typeof AuthenticatedInstancesInstanceIdFindingsRoute
  '/instances/$instanceId/insights': typeof AuthenticatedInstancesInstanceIdInsightsRoute
  '/instances/$instanceId/operations': typeof AuthenticatedInstancesInstanceIdOperationsRoute
  '/instances/$instanceId/packs': typeof AuthenticatedInstancesInstanceIdPacksRouteWithChildren
  '/optimization/opportunities/$opportunityId': typeof AuthenticatedOptimizationOpportunitiesOpportunityIdRoute
  '/agents/$agentId': typeof AuthenticatedAgentsAgentIdIndexRoute
  '/automation/post-actions': typeof AuthenticatedAutomationPostActionsIndexRoute
  '/automation/templates': typeof AuthenticatedAutomationTemplatesIndexRoute
  '/instances/$instanceId/': typeof AuthenticatedInstancesInstanceIdIndexRoute
  '/optimization/opportunities': typeof AuthenticatedOptimizationOpportunitiesIndexRoute
  '/automation/templates/$templateId/edit': typeof AuthenticatedAutomationTemplatesTemplateIdEditRoute
  '/copilot/$instanceId/suggestions/$suggestionId': typeof AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute
  '/instances/$instanceId/diagnostics/$resultId': typeof AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute
  '/instances/$instanceId/packs/$packSlug': typeof AuthenticatedInstancesInstanceIdPacksPackSlugRoute
  '/instances/$instanceId/diagnostics': typeof AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute
  '/instances/$instanceId/packs/': typeof AuthenticatedInstancesInstanceIdPacksIndexRoute
}
export interface FileRoutesByTo {
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/signup-pending': typeof authSignupPendingRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/automation/governed-tools': typeof AuthenticatedAutomationGovernedToolsRoute
  '/automation/monitors': typeof AuthenticatedAutomationMonitorsRoute
  '/automation/pack-studio': typeof AuthenticatedAutomationPackStudioRoute
  '/command-center/data-catalog': typeof AuthenticatedCommandCenterDataCatalogRoute
  '/command-center/drift': typeof AuthenticatedCommandCenterDriftRoute
  '/command-center/pii': typeof AuthenticatedCommandCenterPiiRoute
  '/command-center/sanitize': typeof AuthenticatedCommandCenterSanitizeRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/optimization/billing': typeof AuthenticatedOptimizationBillingRoute
  '/packs/$packSlug': typeof AuthenticatedPacksPackSlugRoute
  '/reports/$runId': typeof AuthenticatedReportsRunIdRoute
  '/reports/new': typeof AuthenticatedReportsNewRoute
  '/settings/agent-keys': typeof AuthenticatedSettingsAgentKeysRoute
  '/settings/governed-tools': typeof AuthenticatedSettingsGovernedToolsRoute
  '/settings/optimization': typeof AuthenticatedSettingsOptimizationRoute
  '/settings/post-actions': typeof AuthenticatedSettingsPostActionsRoute
  '/settings/report-profiles': typeof AuthenticatedSettingsReportProfilesRoute
  '/settings/report-subscriptions': typeof AuthenticatedSettingsReportSubscriptionsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/access-governance': typeof AuthenticatedAccessGovernanceIndexRoute
  '/agents': typeof AuthenticatedAgentsIndexRoute
  '/alerts': typeof AuthenticatedAlertsIndexRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/backups': typeof AuthenticatedBackupsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/command-center': typeof AuthenticatedCommandCenterIndexRoute
  '/compliance': typeof AuthenticatedComplianceIndexRoute
  '/copilot': typeof AuthenticatedCopilotIndexRoute
  '/insights': typeof AuthenticatedInsightsIndexRoute
  '/instances': typeof AuthenticatedInstancesIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/monitoring': typeof AuthenticatedMonitoringIndexRoute
  '/optimization': typeof AuthenticatedOptimizationIndexRoute
  '/outcomes': typeof AuthenticatedOutcomesIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/automation/templates/$templateId': typeof AuthenticatedAutomationTemplatesTemplateIdRouteWithChildren
  '/automation/templates/create': typeof AuthenticatedAutomationTemplatesCreateRoute
  '/instances/$instanceId/access': typeof AuthenticatedInstancesInstanceIdAccessRoute
  '/instances/$instanceId/alerts': typeof AuthenticatedInstancesInstanceIdAlertsRoute
  '/instances/$instanceId/compliance': typeof AuthenticatedInstancesInstanceIdComplianceRoute
  '/instances/$instanceId/findings': typeof AuthenticatedInstancesInstanceIdFindingsRoute
  '/instances/$instanceId/insights': typeof AuthenticatedInstancesInstanceIdInsightsRoute
  '/instances/$instanceId/operations': typeof AuthenticatedInstancesInstanceIdOperationsRoute
  '/optimization/opportunities/$opportunityId': typeof AuthenticatedOptimizationOpportunitiesOpportunityIdRoute
  '/agents/$agentId': typeof AuthenticatedAgentsAgentIdIndexRoute
  '/automation/post-actions': typeof AuthenticatedAutomationPostActionsIndexRoute
  '/automation/templates': typeof AuthenticatedAutomationTemplatesIndexRoute
  '/instances/$instanceId': typeof AuthenticatedInstancesInstanceIdIndexRoute
  '/optimization/opportunities': typeof AuthenticatedOptimizationOpportunitiesIndexRoute
  '/automation/templates/$templateId/edit': typeof AuthenticatedAutomationTemplatesTemplateIdEditRoute
  '/copilot/$instanceId/suggestions/$suggestionId': typeof AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute
  '/instances/$instanceId/diagnostics/$resultId': typeof AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute
  '/instances/$instanceId/packs/$packSlug': typeof AuthenticatedInstancesInstanceIdPacksPackSlugRoute
  '/instances/$instanceId/diagnostics': typeof AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute
  '/instances/$instanceId/packs': typeof AuthenticatedInstancesInstanceIdPacksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(auth)/signup-pending': typeof authSignupPendingRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/automation/governed-tools': typeof AuthenticatedAutomationGovernedToolsRoute
  '/_authenticated/automation/monitors': typeof AuthenticatedAutomationMonitorsRoute
  '/_authenticated/automation/pack-studio': typeof AuthenticatedAutomationPackStudioRoute
  '/_authenticated/command-center/data-catalog': typeof AuthenticatedCommandCenterDataCatalogRoute
  '/_authenticated/command-center/drift': typeof AuthenticatedCommandCenterDriftRoute
  '/_authenticated/command-center/pii': typeof AuthenticatedCommandCenterPiiRoute
  '/_authenticated/command-center/sanitize': typeof AuthenticatedCommandCenterSanitizeRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/instances/$instanceId': typeof AuthenticatedInstancesInstanceIdRouteWithChildren
  '/_authenticated/optimization/billing': typeof AuthenticatedOptimizationBillingRoute
  '/_authenticated/packs/$packSlug': typeof AuthenticatedPacksPackSlugRoute
  '/_authenticated/reports/$runId': typeof AuthenticatedReportsRunIdRoute
  '/_authenticated/reports/new': typeof AuthenticatedReportsNewRoute
  '/_authenticated/settings/agent-keys': typeof AuthenticatedSettingsAgentKeysRoute
  '/_authenticated/settings/governed-tools': typeof AuthenticatedSettingsGovernedToolsRoute
  '/_authenticated/settings/optimization': typeof AuthenticatedSettingsOptimizationRoute
  '/_authenticated/settings/post-actions': typeof AuthenticatedSettingsPostActionsRoute
  '/_authenticated/settings/report-profiles': typeof AuthenticatedSettingsReportProfilesRoute
  '/_authenticated/settings/report-subscriptions': typeof AuthenticatedSettingsReportSubscriptionsRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/clerk/_authenticated/user-management': typeof ClerkAuthenticatedUserManagementRoute
  '/_authenticated/access-governance/': typeof AuthenticatedAccessGovernanceIndexRoute
  '/_authenticated/agents/': typeof AuthenticatedAgentsIndexRoute
  '/_authenticated/alerts/': typeof AuthenticatedAlertsIndexRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/backups/': typeof AuthenticatedBackupsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/command-center/': typeof AuthenticatedCommandCenterIndexRoute
  '/_authenticated/compliance/': typeof AuthenticatedComplianceIndexRoute
  '/_authenticated/copilot/': typeof AuthenticatedCopilotIndexRoute
  '/_authenticated/insights/': typeof AuthenticatedInsightsIndexRoute
  '/_authenticated/instances/': typeof AuthenticatedInstancesIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/monitoring/': typeof AuthenticatedMonitoringIndexRoute
  '/_authenticated/optimization/': typeof AuthenticatedOptimizationIndexRoute
  '/_authenticated/outcomes/': typeof AuthenticatedOutcomesIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/automation/templates/$templateId': typeof AuthenticatedAutomationTemplatesTemplateIdRouteWithChildren
  '/_authenticated/automation/templates/create': typeof AuthenticatedAutomationTemplatesCreateRoute
  '/_authenticated/instances/$instanceId/access': typeof AuthenticatedInstancesInstanceIdAccessRoute
  '/_authenticated/instances/$instanceId/alerts': typeof AuthenticatedInstancesInstanceIdAlertsRoute
  '/_authenticated/instances/$instanceId/compliance': typeof AuthenticatedInstancesInstanceIdComplianceRoute
  '/_authenticated/instances/$instanceId/findings': typeof AuthenticatedInstancesInstanceIdFindingsRoute
  '/_authenticated/instances/$instanceId/insights': typeof AuthenticatedInstancesInstanceIdInsightsRoute
  '/_authenticated/instances/$instanceId/operations': typeof AuthenticatedInstancesInstanceIdOperationsRoute
  '/_authenticated/instances/$instanceId/packs': typeof AuthenticatedInstancesInstanceIdPacksRouteWithChildren
  '/_authenticated/optimization/opportunities/$opportunityId': typeof AuthenticatedOptimizationOpportunitiesOpportunityIdRoute
  '/_authenticated/agents/$agentId/': typeof AuthenticatedAgentsAgentIdIndexRoute
  '/_authenticated/automation/post-actions/': typeof AuthenticatedAutomationPostActionsIndexRoute
  '/_authenticated/automation/templates/': typeof AuthenticatedAutomationTemplatesIndexRoute
  '/_authenticated/instances/$instanceId/': typeof AuthenticatedInstancesInstanceIdIndexRoute
  '/_authenticated/optimization/opportunities/': typeof AuthenticatedOptimizationOpportunitiesIndexRoute
  '/_authenticated/automation/templates/$templateId/edit': typeof AuthenticatedAutomationTemplatesTemplateIdEditRoute
  '/_authenticated/copilot/$instanceId/suggestions/$suggestionId': typeof AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute
  '/_authenticated/instances/$instanceId/diagnostics/$resultId': typeof AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute
  '/_authenticated/instances/$instanceId/packs/$packSlug': typeof AuthenticatedInstancesInstanceIdPacksPackSlugRoute
  '/_authenticated/instances/$instanceId/diagnostics/': typeof AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute
  '/_authenticated/instances/$instanceId/packs/': typeof AuthenticatedInstancesInstanceIdPacksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/clerk'
    | '/settings'
    | '/clerk/'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-up'
    | '/signup-pending'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/automation/governed-tools'
    | '/automation/monitors'
    | '/automation/pack-studio'
    | '/command-center/data-catalog'
    | '/command-center/drift'
    | '/command-center/pii'
    | '/command-center/sanitize'
    | '/errors/$error'
    | '/instances/$instanceId'
    | '/optimization/billing'
    | '/packs/$packSlug'
    | '/reports/$runId'
    | '/reports/new'
    | '/settings/agent-keys'
    | '/settings/governed-tools'
    | '/settings/optimization'
    | '/settings/post-actions'
    | '/settings/report-profiles'
    | '/settings/report-subscriptions'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/access-governance'
    | '/agents'
    | '/alerts'
    | '/apps'
    | '/backups'
    | '/chats'
    | '/command-center'
    | '/compliance'
    | '/copilot'
    | '/insights'
    | '/instances'
    | '/jobs'
    | '/monitoring'
    | '/optimization'
    | '/outcomes'
    | '/reports'
    | '/tasks'
    | '/users'
    | '/automation/templates/$templateId'
    | '/automation/templates/create'
    | '/instances/$instanceId/access'
    | '/instances/$instanceId/alerts'
    | '/instances/$instanceId/compliance'
    | '/instances/$instanceId/findings'
    | '/instances/$instanceId/insights'
    | '/instances/$instanceId/operations'
    | '/instances/$instanceId/packs'
    | '/optimization/opportunities/$opportunityId'
    | '/agents/$agentId'
    | '/automation/post-actions'
    | '/automation/templates'
    | '/instances/$instanceId/'
    | '/optimization/opportunities'
    | '/automation/templates/$templateId/edit'
    | '/copilot/$instanceId/suggestions/$suggestionId'
    | '/instances/$instanceId/diagnostics/$resultId'
    | '/instances/$instanceId/packs/$packSlug'
    | '/instances/$instanceId/diagnostics'
    | '/instances/$instanceId/packs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/settings'
    | '/clerk'
    | '/forgot-password'
    | '/otp'
    | '/sign-in'
    | '/sign-up'
    | '/signup-pending'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/automation/governed-tools'
    | '/automation/monitors'
    | '/automation/pack-studio'
    | '/command-center/data-catalog'
    | '/command-center/drift'
    | '/command-center/pii'
    | '/command-center/sanitize'
    | '/errors/$error'
    | '/optimization/billing'
    | '/packs/$packSlug'
    | '/reports/$runId'
    | '/reports/new'
    | '/settings/agent-keys'
    | '/settings/governed-tools'
    | '/settings/optimization'
    | '/settings/post-actions'
    | '/settings/report-profiles'
    | '/settings/report-subscriptions'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/clerk/user-management'
    | '/access-governance'
    | '/agents'
    | '/alerts'
    | '/apps'
    | '/backups'
    | '/chats'
    | '/command-center'
    | '/compliance'
    | '/copilot'
    | '/insights'
    | '/instances'
    | '/jobs'
    | '/monitoring'
    | '/optimization'
    | '/outcomes'
    | '/reports'
    | '/tasks'
    | '/users'
    | '/automation/templates/$templateId'
    | '/automation/templates/create'
    | '/instances/$instanceId/access'
    | '/instances/$instanceId/alerts'
    | '/instances/$instanceId/compliance'
    | '/instances/$instanceId/findings'
    | '/instances/$instanceId/insights'
    | '/instances/$instanceId/operations'
    | '/optimization/opportunities/$opportunityId'
    | '/agents/$agentId'
    | '/automation/post-actions'
    | '/automation/templates'
    | '/instances/$instanceId'
    | '/optimization/opportunities'
    | '/automation/templates/$templateId/edit'
    | '/copilot/$instanceId/suggestions/$suggestionId'
    | '/instances/$instanceId/diagnostics/$resultId'
    | '/instances/$instanceId/packs/$packSlug'
    | '/instances/$instanceId/diagnostics'
    | '/instances/$instanceId/packs'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/(auth)/signup-pending'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/automation/governed-tools'
    | '/_authenticated/automation/monitors'
    | '/_authenticated/automation/pack-studio'
    | '/_authenticated/command-center/data-catalog'
    | '/_authenticated/command-center/drift'
    | '/_authenticated/command-center/pii'
    | '/_authenticated/command-center/sanitize'
    | '/_authenticated/errors/$error'
    | '/_authenticated/instances/$instanceId'
    | '/_authenticated/optimization/billing'
    | '/_authenticated/packs/$packSlug'
    | '/_authenticated/reports/$runId'
    | '/_authenticated/reports/new'
    | '/_authenticated/settings/agent-keys'
    | '/_authenticated/settings/governed-tools'
    | '/_authenticated/settings/optimization'
    | '/_authenticated/settings/post-actions'
    | '/_authenticated/settings/report-profiles'
    | '/_authenticated/settings/report-subscriptions'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/clerk/_authenticated/user-management'
    | '/_authenticated/access-governance/'
    | '/_authenticated/agents/'
    | '/_authenticated/alerts/'
    | '/_authenticated/apps/'
    | '/_authenticated/backups/'
    | '/_authenticated/chats/'
    | '/_authenticated/command-center/'
    | '/_authenticated/compliance/'
    | '/_authenticated/copilot/'
    | '/_authenticated/insights/'
    | '/_authenticated/instances/'
    | '/_authenticated/jobs/'
    | '/_authenticated/monitoring/'
    | '/_authenticated/optimization/'
    | '/_authenticated/outcomes/'
    | '/_authenticated/reports/'
    | '/_authenticated/tasks/'
    | '/_authenticated/users/'
    | '/_authenticated/automation/templates/$templateId'
    | '/_authenticated/automation/templates/create'
    | '/_authenticated/instances/$instanceId/access'
    | '/_authenticated/instances/$instanceId/alerts'
    | '/_authenticated/instances/$instanceId/compliance'
    | '/_authenticated/instances/$instanceId/findings'
    | '/_authenticated/instances/$instanceId/insights'
    | '/_authenticated/instances/$instanceId/operations'
    | '/_authenticated/instances/$instanceId/packs'
    | '/_authenticated/optimization/opportunities/$opportunityId'
    | '/_authenticated/agents/$agentId/'
    | '/_authenticated/automation/post-actions/'
    | '/_authenticated/automation/templates/'
    | '/_authenticated/instances/$instanceId/'
    | '/_authenticated/optimization/opportunities/'
    | '/_authenticated/automation/templates/$templateId/edit'
    | '/_authenticated/copilot/$instanceId/suggestions/$suggestionId'
    | '/_authenticated/instances/$instanceId/diagnostics/$resultId'
    | '/_authenticated/instances/$instanceId/packs/$packSlug'
    | '/_authenticated/instances/$instanceId/diagnostics/'
    | '/_authenticated/instances/$instanceId/packs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
  authSignupPendingRoute: typeof authSignupPendingRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/signup-pending': {
      id: '/(auth)/signup-pending'
      path: '/signup-pending'
      fullPath: '/signup-pending'
      preLoaderRoute: typeof authSignupPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: '/'
      fullPath: '/clerk/'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/outcomes/': {
      id: '/_authenticated/outcomes/'
      path: '/outcomes'
      fullPath: '/outcomes'
      preLoaderRoute: typeof AuthenticatedOutcomesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/optimization/': {
      id: '/_authenticated/optimization/'
      path: '/optimization'
      fullPath: '/optimization'
      preLoaderRoute: typeof AuthenticatedOptimizationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/monitoring/': {
      id: '/_authenticated/monitoring/'
      path: '/monitoring'
      fullPath: '/monitoring'
      preLoaderRoute: typeof AuthenticatedMonitoringIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instances/': {
      id: '/_authenticated/instances/'
      path: '/instances'
      fullPath: '/instances'
      preLoaderRoute: typeof AuthenticatedInstancesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/insights/': {
      id: '/_authenticated/insights/'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AuthenticatedInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/copilot/': {
      id: '/_authenticated/copilot/'
      path: '/copilot'
      fullPath: '/copilot'
      preLoaderRoute: typeof AuthenticatedCopilotIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/compliance/': {
      id: '/_authenticated/compliance/'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof AuthenticatedComplianceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/command-center/': {
      id: '/_authenticated/command-center/'
      path: '/command-center'
      fullPath: '/command-center'
      preLoaderRoute: typeof AuthenticatedCommandCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/backups/': {
      id: '/_authenticated/backups/'
      path: '/backups'
      fullPath: '/backups'
      preLoaderRoute: typeof AuthenticatedBackupsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/alerts/': {
      id: '/_authenticated/alerts/'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthenticatedAlertsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/': {
      id: '/_authenticated/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AuthenticatedAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/access-governance/': {
      id: '/_authenticated/access-governance/'
      path: '/access-governance'
      fullPath: '/access-governance'
      preLoaderRoute: typeof AuthenticatedAccessGovernanceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/_authenticated/user-management': {
      id: '/clerk/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/clerk/user-management'
      preLoaderRoute: typeof ClerkAuthenticatedUserManagementRouteImport
      parentRoute: typeof ClerkAuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/settings/report-subscriptions': {
      id: '/_authenticated/settings/report-subscriptions'
      path: '/report-subscriptions'
      fullPath: '/settings/report-subscriptions'
      preLoaderRoute: typeof AuthenticatedSettingsReportSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/report-profiles': {
      id: '/_authenticated/settings/report-profiles'
      path: '/report-profiles'
      fullPath: '/settings/report-profiles'
      preLoaderRoute: typeof AuthenticatedSettingsReportProfilesRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/post-actions': {
      id: '/_authenticated/settings/post-actions'
      path: '/post-actions'
      fullPath: '/settings/post-actions'
      preLoaderRoute: typeof AuthenticatedSettingsPostActionsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/optimization': {
      id: '/_authenticated/settings/optimization'
      path: '/optimization'
      fullPath: '/settings/optimization'
      preLoaderRoute: typeof AuthenticatedSettingsOptimizationRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/governed-tools': {
      id: '/_authenticated/settings/governed-tools'
      path: '/governed-tools'
      fullPath: '/settings/governed-tools'
      preLoaderRoute: typeof AuthenticatedSettingsGovernedToolsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/agent-keys': {
      id: '/_authenticated/settings/agent-keys'
      path: '/agent-keys'
      fullPath: '/settings/agent-keys'
      preLoaderRoute: typeof AuthenticatedSettingsAgentKeysRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/reports/new': {
      id: '/_authenticated/reports/new'
      path: '/reports/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof AuthenticatedReportsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reports/$runId': {
      id: '/_authenticated/reports/$runId'
      path: '/reports/$runId'
      fullPath: '/reports/$runId'
      preLoaderRoute: typeof AuthenticatedReportsRunIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/packs/$packSlug': {
      id: '/_authenticated/packs/$packSlug'
      path: '/packs/$packSlug'
      fullPath: '/packs/$packSlug'
      preLoaderRoute: typeof AuthenticatedPacksPackSlugRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/optimization/billing': {
      id: '/_authenticated/optimization/billing'
      path: '/optimization/billing'
      fullPath: '/optimization/billing'
      preLoaderRoute: typeof AuthenticatedOptimizationBillingRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instances/$instanceId': {
      id: '/_authenticated/instances/$instanceId'
      path: '/instances/$instanceId'
      fullPath: '/instances/$instanceId'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/command-center/sanitize': {
      id: '/_authenticated/command-center/sanitize'
      path: '/command-center/sanitize'
      fullPath: '/command-center/sanitize'
      preLoaderRoute: typeof AuthenticatedCommandCenterSanitizeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/command-center/pii': {
      id: '/_authenticated/command-center/pii'
      path: '/command-center/pii'
      fullPath: '/command-center/pii'
      preLoaderRoute: typeof AuthenticatedCommandCenterPiiRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/command-center/drift': {
      id: '/_authenticated/command-center/drift'
      path: '/command-center/drift'
      fullPath: '/command-center/drift'
      preLoaderRoute: typeof AuthenticatedCommandCenterDriftRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/command-center/data-catalog': {
      id: '/_authenticated/command-center/data-catalog'
      path: '/command-center/data-catalog'
      fullPath: '/command-center/data-catalog'
      preLoaderRoute: typeof AuthenticatedCommandCenterDataCatalogRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/automation/pack-studio': {
      id: '/_authenticated/automation/pack-studio'
      path: '/automation/pack-studio'
      fullPath: '/automation/pack-studio'
      preLoaderRoute: typeof AuthenticatedAutomationPackStudioRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/automation/monitors': {
      id: '/_authenticated/automation/monitors'
      path: '/automation/monitors'
      fullPath: '/automation/monitors'
      preLoaderRoute: typeof AuthenticatedAutomationMonitorsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/automation/governed-tools': {
      id: '/_authenticated/automation/governed-tools'
      path: '/automation/governed-tools'
      fullPath: '/automation/governed-tools'
      preLoaderRoute: typeof AuthenticatedAutomationGovernedToolsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/optimization/opportunities/': {
      id: '/_authenticated/optimization/opportunities/'
      path: '/optimization/opportunities'
      fullPath: '/optimization/opportunities'
      preLoaderRoute: typeof AuthenticatedOptimizationOpportunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instances/$instanceId/': {
      id: '/_authenticated/instances/$instanceId/'
      path: '/'
      fullPath: '/instances/$instanceId/'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdIndexRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/automation/templates/': {
      id: '/_authenticated/automation/templates/'
      path: '/automation/templates'
      fullPath: '/automation/templates'
      preLoaderRoute: typeof AuthenticatedAutomationTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/automation/post-actions/': {
      id: '/_authenticated/automation/post-actions/'
      path: '/automation/post-actions'
      fullPath: '/automation/post-actions'
      preLoaderRoute: typeof AuthenticatedAutomationPostActionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/agents/$agentId/': {
      id: '/_authenticated/agents/$agentId/'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthenticatedAgentsAgentIdIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/optimization/opportunities/$opportunityId': {
      id: '/_authenticated/optimization/opportunities/$opportunityId'
      path: '/optimization/opportunities/$opportunityId'
      fullPath: '/optimization/opportunities/$opportunityId'
      preLoaderRoute: typeof AuthenticatedOptimizationOpportunitiesOpportunityIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instances/$instanceId/packs': {
      id: '/_authenticated/instances/$instanceId/packs'
      path: '/packs'
      fullPath: '/instances/$instanceId/packs'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdPacksRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/operations': {
      id: '/_authenticated/instances/$instanceId/operations'
      path: '/operations'
      fullPath: '/instances/$instanceId/operations'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdOperationsRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/insights': {
      id: '/_authenticated/instances/$instanceId/insights'
      path: '/insights'
      fullPath: '/instances/$instanceId/insights'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdInsightsRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/findings': {
      id: '/_authenticated/instances/$instanceId/findings'
      path: '/findings'
      fullPath: '/instances/$instanceId/findings'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdFindingsRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/compliance': {
      id: '/_authenticated/instances/$instanceId/compliance'
      path: '/compliance'
      fullPath: '/instances/$instanceId/compliance'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdComplianceRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/alerts': {
      id: '/_authenticated/instances/$instanceId/alerts'
      path: '/alerts'
      fullPath: '/instances/$instanceId/alerts'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdAlertsRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/access': {
      id: '/_authenticated/instances/$instanceId/access'
      path: '/access'
      fullPath: '/instances/$instanceId/access'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdAccessRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/automation/templates/create': {
      id: '/_authenticated/automation/templates/create'
      path: '/automation/templates/create'
      fullPath: '/automation/templates/create'
      preLoaderRoute: typeof AuthenticatedAutomationTemplatesCreateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/automation/templates/$templateId': {
      id: '/_authenticated/automation/templates/$templateId'
      path: '/automation/templates/$templateId'
      fullPath: '/automation/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedAutomationTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/instances/$instanceId/packs/': {
      id: '/_authenticated/instances/$instanceId/packs/'
      path: '/'
      fullPath: '/instances/$instanceId/packs/'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdPacksIndexRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdPacksRoute
    }
    '/_authenticated/instances/$instanceId/diagnostics/': {
      id: '/_authenticated/instances/$instanceId/diagnostics/'
      path: '/diagnostics'
      fullPath: '/instances/$instanceId/diagnostics'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdDiagnosticsIndexRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/instances/$instanceId/packs/$packSlug': {
      id: '/_authenticated/instances/$instanceId/packs/$packSlug'
      path: '/$packSlug'
      fullPath: '/instances/$instanceId/packs/$packSlug'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdPacksPackSlugRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdPacksRoute
    }
    '/_authenticated/instances/$instanceId/diagnostics/$resultId': {
      id: '/_authenticated/instances/$instanceId/diagnostics/$resultId'
      path: '/diagnostics/$resultId'
      fullPath: '/instances/$instanceId/diagnostics/$resultId'
      preLoaderRoute: typeof AuthenticatedInstancesInstanceIdDiagnosticsResultIdRouteImport
      parentRoute: typeof AuthenticatedInstancesInstanceIdRoute
    }
    '/_authenticated/copilot/$instanceId/suggestions/$suggestionId': {
      id: '/_authenticated/copilot/$instanceId/suggestions/$suggestionId'
      path: '/copilot/$instanceId/suggestions/$suggestionId'
      fullPath: '/copilot/$instanceId/suggestions/$suggestionId'
      preLoaderRoute: typeof AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/automation/templates/$templateId/edit': {
      id: '/_authenticated/automation/templates/$templateId/edit'
      path: '/edit'
      fullPath: '/automation/templates/$templateId/edit'
      preLoaderRoute: typeof AuthenticatedAutomationTemplatesTemplateIdEditRouteImport
      parentRoute: typeof AuthenticatedAutomationTemplatesTemplateIdRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAgentKeysRoute: typeof AuthenticatedSettingsAgentKeysRoute
  AuthenticatedSettingsGovernedToolsRoute: typeof AuthenticatedSettingsGovernedToolsRoute
  AuthenticatedSettingsOptimizationRoute: typeof AuthenticatedSettingsOptimizationRoute
  AuthenticatedSettingsPostActionsRoute: typeof AuthenticatedSettingsPostActionsRoute
  AuthenticatedSettingsReportProfilesRoute: typeof AuthenticatedSettingsReportProfilesRoute
  AuthenticatedSettingsReportSubscriptionsRoute: typeof AuthenticatedSettingsReportSubscriptionsRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAgentKeysRoute: AuthenticatedSettingsAgentKeysRoute,
    AuthenticatedSettingsGovernedToolsRoute:
      AuthenticatedSettingsGovernedToolsRoute,
    AuthenticatedSettingsOptimizationRoute:
      AuthenticatedSettingsOptimizationRoute,
    AuthenticatedSettingsPostActionsRoute:
      AuthenticatedSettingsPostActionsRoute,
    AuthenticatedSettingsReportProfilesRoute:
      AuthenticatedSettingsReportProfilesRoute,
    AuthenticatedSettingsReportSubscriptionsRoute:
      AuthenticatedSettingsReportSubscriptionsRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedInstancesInstanceIdPacksRouteChildren {
  AuthenticatedInstancesInstanceIdPacksPackSlugRoute: typeof AuthenticatedInstancesInstanceIdPacksPackSlugRoute
  AuthenticatedInstancesInstanceIdPacksIndexRoute: typeof AuthenticatedInstancesInstanceIdPacksIndexRoute
}

const AuthenticatedInstancesInstanceIdPacksRouteChildren: AuthenticatedInstancesInstanceIdPacksRouteChildren =
  {
    AuthenticatedInstancesInstanceIdPacksPackSlugRoute:
      AuthenticatedInstancesInstanceIdPacksPackSlugRoute,
    AuthenticatedInstancesInstanceIdPacksIndexRoute:
      AuthenticatedInstancesInstanceIdPacksIndexRoute,
  }

const AuthenticatedInstancesInstanceIdPacksRouteWithChildren =
  AuthenticatedInstancesInstanceIdPacksRoute._addFileChildren(
    AuthenticatedInstancesInstanceIdPacksRouteChildren,
  )

interface AuthenticatedInstancesInstanceIdRouteChildren {
  AuthenticatedInstancesInstanceIdAccessRoute: typeof AuthenticatedInstancesInstanceIdAccessRoute
  AuthenticatedInstancesInstanceIdAlertsRoute: typeof AuthenticatedInstancesInstanceIdAlertsRoute
  AuthenticatedInstancesInstanceIdComplianceRoute: typeof AuthenticatedInstancesInstanceIdComplianceRoute
  AuthenticatedInstancesInstanceIdFindingsRoute: typeof AuthenticatedInstancesInstanceIdFindingsRoute
  AuthenticatedInstancesInstanceIdInsightsRoute: typeof AuthenticatedInstancesInstanceIdInsightsRoute
  AuthenticatedInstancesInstanceIdOperationsRoute: typeof AuthenticatedInstancesInstanceIdOperationsRoute
  AuthenticatedInstancesInstanceIdPacksRoute: typeof AuthenticatedInstancesInstanceIdPacksRouteWithChildren
  AuthenticatedInstancesInstanceIdIndexRoute: typeof AuthenticatedInstancesInstanceIdIndexRoute
  AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute: typeof AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute
  AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute: typeof AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute
}

const AuthenticatedInstancesInstanceIdRouteChildren: AuthenticatedInstancesInstanceIdRouteChildren =
  {
    AuthenticatedInstancesInstanceIdAccessRoute:
      AuthenticatedInstancesInstanceIdAccessRoute,
    AuthenticatedInstancesInstanceIdAlertsRoute:
      AuthenticatedInstancesInstanceIdAlertsRoute,
    AuthenticatedInstancesInstanceIdComplianceRoute:
      AuthenticatedInstancesInstanceIdComplianceRoute,
    AuthenticatedInstancesInstanceIdFindingsRoute:
      AuthenticatedInstancesInstanceIdFindingsRoute,
    AuthenticatedInstancesInstanceIdInsightsRoute:
      AuthenticatedInstancesInstanceIdInsightsRoute,
    AuthenticatedInstancesInstanceIdOperationsRoute:
      AuthenticatedInstancesInstanceIdOperationsRoute,
    AuthenticatedInstancesInstanceIdPacksRoute:
      AuthenticatedInstancesInstanceIdPacksRouteWithChildren,
    AuthenticatedInstancesInstanceIdIndexRoute:
      AuthenticatedInstancesInstanceIdIndexRoute,
    AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute:
      AuthenticatedInstancesInstanceIdDiagnosticsResultIdRoute,
    AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute:
      AuthenticatedInstancesInstanceIdDiagnosticsIndexRoute,
  }

const AuthenticatedInstancesInstanceIdRouteWithChildren =
  AuthenticatedInstancesInstanceIdRoute._addFileChildren(
    AuthenticatedInstancesInstanceIdRouteChildren,
  )

interface AuthenticatedAutomationTemplatesTemplateIdRouteChildren {
  AuthenticatedAutomationTemplatesTemplateIdEditRoute: typeof AuthenticatedAutomationTemplatesTemplateIdEditRoute
}

const AuthenticatedAutomationTemplatesTemplateIdRouteChildren: AuthenticatedAutomationTemplatesTemplateIdRouteChildren =
  {
    AuthenticatedAutomationTemplatesTemplateIdEditRoute:
      AuthenticatedAutomationTemplatesTemplateIdEditRoute,
  }

const AuthenticatedAutomationTemplatesTemplateIdRouteWithChildren =
  AuthenticatedAutomationTemplatesTemplateIdRoute._addFileChildren(
    AuthenticatedAutomationTemplatesTemplateIdRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAutomationGovernedToolsRoute: typeof AuthenticatedAutomationGovernedToolsRoute
  AuthenticatedAutomationMonitorsRoute: typeof AuthenticatedAutomationMonitorsRoute
  AuthenticatedAutomationPackStudioRoute: typeof AuthenticatedAutomationPackStudioRoute
  AuthenticatedCommandCenterDataCatalogRoute: typeof AuthenticatedCommandCenterDataCatalogRoute
  AuthenticatedCommandCenterDriftRoute: typeof AuthenticatedCommandCenterDriftRoute
  AuthenticatedCommandCenterPiiRoute: typeof AuthenticatedCommandCenterPiiRoute
  AuthenticatedCommandCenterSanitizeRoute: typeof AuthenticatedCommandCenterSanitizeRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedInstancesInstanceIdRoute: typeof AuthenticatedInstancesInstanceIdRouteWithChildren
  AuthenticatedOptimizationBillingRoute: typeof AuthenticatedOptimizationBillingRoute
  AuthenticatedPacksPackSlugRoute: typeof AuthenticatedPacksPackSlugRoute
  AuthenticatedReportsRunIdRoute: typeof AuthenticatedReportsRunIdRoute
  AuthenticatedReportsNewRoute: typeof AuthenticatedReportsNewRoute
  AuthenticatedAccessGovernanceIndexRoute: typeof AuthenticatedAccessGovernanceIndexRoute
  AuthenticatedAgentsIndexRoute: typeof AuthenticatedAgentsIndexRoute
  AuthenticatedAlertsIndexRoute: typeof AuthenticatedAlertsIndexRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedBackupsIndexRoute: typeof AuthenticatedBackupsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedCommandCenterIndexRoute: typeof AuthenticatedCommandCenterIndexRoute
  AuthenticatedComplianceIndexRoute: typeof AuthenticatedComplianceIndexRoute
  AuthenticatedCopilotIndexRoute: typeof AuthenticatedCopilotIndexRoute
  AuthenticatedInsightsIndexRoute: typeof AuthenticatedInsightsIndexRoute
  AuthenticatedInstancesIndexRoute: typeof AuthenticatedInstancesIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedMonitoringIndexRoute: typeof AuthenticatedMonitoringIndexRoute
  AuthenticatedOptimizationIndexRoute: typeof AuthenticatedOptimizationIndexRoute
  AuthenticatedOutcomesIndexRoute: typeof AuthenticatedOutcomesIndexRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedAutomationTemplatesTemplateIdRoute: typeof AuthenticatedAutomationTemplatesTemplateIdRouteWithChildren
  AuthenticatedAutomationTemplatesCreateRoute: typeof AuthenticatedAutomationTemplatesCreateRoute
  AuthenticatedOptimizationOpportunitiesOpportunityIdRoute: typeof AuthenticatedOptimizationOpportunitiesOpportunityIdRoute
  AuthenticatedAgentsAgentIdIndexRoute: typeof AuthenticatedAgentsAgentIdIndexRoute
  AuthenticatedAutomationPostActionsIndexRoute: typeof AuthenticatedAutomationPostActionsIndexRoute
  AuthenticatedAutomationTemplatesIndexRoute: typeof AuthenticatedAutomationTemplatesIndexRoute
  AuthenticatedOptimizationOpportunitiesIndexRoute: typeof AuthenticatedOptimizationOpportunitiesIndexRoute
  AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute: typeof AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAutomationGovernedToolsRoute:
    AuthenticatedAutomationGovernedToolsRoute,
  AuthenticatedAutomationMonitorsRoute: AuthenticatedAutomationMonitorsRoute,
  AuthenticatedAutomationPackStudioRoute:
    AuthenticatedAutomationPackStudioRoute,
  AuthenticatedCommandCenterDataCatalogRoute:
    AuthenticatedCommandCenterDataCatalogRoute,
  AuthenticatedCommandCenterDriftRoute: AuthenticatedCommandCenterDriftRoute,
  AuthenticatedCommandCenterPiiRoute: AuthenticatedCommandCenterPiiRoute,
  AuthenticatedCommandCenterSanitizeRoute:
    AuthenticatedCommandCenterSanitizeRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedInstancesInstanceIdRoute:
    AuthenticatedInstancesInstanceIdRouteWithChildren,
  AuthenticatedOptimizationBillingRoute: AuthenticatedOptimizationBillingRoute,
  AuthenticatedPacksPackSlugRoute: AuthenticatedPacksPackSlugRoute,
  AuthenticatedReportsRunIdRoute: AuthenticatedReportsRunIdRoute,
  AuthenticatedReportsNewRoute: AuthenticatedReportsNewRoute,
  AuthenticatedAccessGovernanceIndexRoute:
    AuthenticatedAccessGovernanceIndexRoute,
  AuthenticatedAgentsIndexRoute: AuthenticatedAgentsIndexRoute,
  AuthenticatedAlertsIndexRoute: AuthenticatedAlertsIndexRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedBackupsIndexRoute: AuthenticatedBackupsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedCommandCenterIndexRoute: AuthenticatedCommandCenterIndexRoute,
  AuthenticatedComplianceIndexRoute: AuthenticatedComplianceIndexRoute,
  AuthenticatedCopilotIndexRoute: AuthenticatedCopilotIndexRoute,
  AuthenticatedInsightsIndexRoute: AuthenticatedInsightsIndexRoute,
  AuthenticatedInstancesIndexRoute: AuthenticatedInstancesIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedMonitoringIndexRoute: AuthenticatedMonitoringIndexRoute,
  AuthenticatedOptimizationIndexRoute: AuthenticatedOptimizationIndexRoute,
  AuthenticatedOutcomesIndexRoute: AuthenticatedOutcomesIndexRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedAutomationTemplatesTemplateIdRoute:
    AuthenticatedAutomationTemplatesTemplateIdRouteWithChildren,
  AuthenticatedAutomationTemplatesCreateRoute:
    AuthenticatedAutomationTemplatesCreateRoute,
  AuthenticatedOptimizationOpportunitiesOpportunityIdRoute:
    AuthenticatedOptimizationOpportunitiesOpportunityIdRoute,
  AuthenticatedAgentsAgentIdIndexRoute: AuthenticatedAgentsAgentIdIndexRoute,
  AuthenticatedAutomationPostActionsIndexRoute:
    AuthenticatedAutomationPostActionsIndexRoute,
  AuthenticatedAutomationTemplatesIndexRoute:
    AuthenticatedAutomationTemplatesIndexRoute,
  AuthenticatedOptimizationOpportunitiesIndexRoute:
    AuthenticatedOptimizationOpportunitiesIndexRoute,
  AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute:
    AuthenticatedCopilotInstanceIdSuggestionsSuggestionIdRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkAuthenticatedRouteRouteChildren {
  ClerkAuthenticatedUserManagementRoute: typeof ClerkAuthenticatedUserManagementRoute
}

const ClerkAuthenticatedRouteRouteChildren: ClerkAuthenticatedRouteRouteChildren =
  {
    ClerkAuthenticatedUserManagementRoute:
      ClerkAuthenticatedUserManagementRoute,
  }

const ClerkAuthenticatedRouteRouteWithChildren =
  ClerkAuthenticatedRouteRoute._addFileChildren(
    ClerkAuthenticatedRouteRouteChildren,
  )

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRouteWithChildren
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRouteWithChildren,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
  authSignupPendingRoute: authSignupPendingRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
